'use strict';

var callDateSet = require('../../common/internal/callDateSet');

function setDate(d, val) {
  callDateSet(d, 'Date', val);
}

module.exports = setDate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/date/internal/setDate.js
// module id = 84
// module chunks = 1